module.exports = __webpack_public_path__ + "img/06-1.e59151e3.png";